import './polyfills/element-classlist';
import './polyfills/element-closest';
import './polyfills/element-matches';
import './polyfills/childnode-remove';
import './polyfills/customevent';
